import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import AdventuresContent from '../components/AdventuresContent';

/**
 * Public Adventures page (iter 79) - `/adventures`.
 *
 * Marketing surface, visible to anyone (no auth). Click tracking uses
 * surface="adventures_public".
 */
const Adventures = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <>
      <SEO
        title="Adventures · Mundalo"
        description="Mexico is your playground. Curated tours, experiences, and once-in-a-lifetime days for the life you came here to live."
        path="/adventures"
      />
      <div className="min-h-screen bg-[#F9F6EF] text-[#0A1F2E]" data-testid="adventures-public-page">
        <Header currentPage="adventures" />
        <AdventuresContent surface="adventures_public" />
        <Footer />
      </div>
    </>
  );
};

export default Adventures;
